export default "__VITE_ASSET__Dc8Jog_U__"